import { Injectable, Signal, inject } from '@angular/core';
import { modalConfig } from '@core/types/types';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly modalService = inject(NgbModal);
  private currentOpenModal: any;

  private modalRefs?: {
    [key: string]: NgbModalRef;
  } = {};

  open(content: any, config: Signal<modalConfig>, ref: string) {
    let modalOptions: NgbModalOptions = {
      centered: true,
      scrollable: true,
      animation: true,
      beforeDismiss: config().beforeDismiss
        ? config().beforeDismiss
        : () => true,
    };

    modalOptions.fullscreen = (config().size as any) == 'fs';
    modalOptions.size = config().size || 'md';

    if (this.modalRefs?.[ref]) {
      this.modalRefs[ref].close();
    }

    const modalRef = this.modalService.open(content, modalOptions);

    modalRef.componentInstance.config = config;
    modalRef.componentInstance.modal = ref;

    this.modalRefs = {
      ...this.modalRefs,
      [ref]: modalRef,
    };

    modalRef.result.then(
      () => {},
      (reason) => {
        this.handleDissmisReason(reason);
      }
    );

    this.currentOpenModal = ref;
  }

  dismiss(ref: string) {
    if (this.modalRefs?.[ref]) {
      this.modalRefs[ref].dismiss();
      delete this.modalRefs[ref];
    }
  }

  close(ref: string) {
    if (this.modalRefs?.[ref]) {
      this.modalRefs[ref].close();
      delete this.modalRefs![ref];
    }
  }

  isModalOpen(ref: string): boolean {
    return this.modalRefs?.[ref] != undefined;
  }

  private handleDissmisReason(reason: any) {
    if (reason == ModalDismissReasons.ESC || reason == ModalDismissReasons.BACKDROP_CLICK)
      this.dismiss(this.currentOpenModal)
  }
}
